import React from 'react';
import { Receipt } from 'lucide-react';
import Card from './ui/Card';
import LanguagePicker from './LanguagePicker';

const AuthLayout = ({ subtitle, children }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-surface-base p-4 relative overflow-hidden">
            {/* Background glow */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="w-[500px] h-[500px] rounded-full bg-accent/5 blur-3xl" />
            </div>

            {/* Language picker — top right corner */}
            <div className="absolute top-4 right-4 z-20">
                <LanguagePicker />
            </div>

            <div className="w-full max-w-sm animate-appear relative z-10">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div className="inline-flex items-center gap-2 mb-3">
                        <Receipt className="w-6 h-6 text-accent" />
                        <span className="text-xl font-bold text-text-primary tracking-tight">
                            Bills<span className="text-accent">ops</span>
                        </span>
                    </div>
                    {subtitle && (
                        <p className="text-sm text-text-muted">{subtitle}</p>
                    )}
                </div>

                <Card>
                    {children}
                </Card>
            </div>
        </div>
    );
};

export default AuthLayout;
